import React, { useState, useEffect } from "react";
import { Paper, Button, TextField } from "@material-ui/core";
import "./Register.css";

let langData = require("../../../Data/language.json");

export default function Register(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [controlPass, setControlPass] = useState("");
  const [error, setError] = useState(props.errorTxt);

  const checkPass = () => {
    if (password === controlPass) {
      props.onRegister(email, password);
    } else {
      setError("Passwords has to match");
    }
  };

  useEffect(() => {
    if (error !== "") {
      setError("");
    }
  }, [email, password, controlPass]);

  return (
    <div className="container-fluid col-lg-8 col-md-11 col-sm-11">
      <Paper
        className="container-fluid"
        id="signUpContainer"
        elevation={6}
        square
      >
        <div className="inputWrapper">
          <h3>{langData[props.language].register.title}</h3>
          <TextField
            id="outlined-email-input"
            label={langData[props.language].register.email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            name="email"
            autoComplete="email"
            margin="normal"
            variant="outlined"
          />
          <br />
          <TextField
            id="outlined-password-input"
            label={langData[props.language].register.password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            autoComplete="current-password"
            margin="normal"
            variant="outlined"
          />
          <br />
          <TextField
            id="outlined-re-password-input"
            label={langData[props.language].register.repeatPassword}
            onChange={(e) => setControlPass(e.target.value)}
            type="password"
            autoComplete="current-password"
            margin="normal"
            variant="outlined"
          />
          <p>{error}</p>
          <Button variant="outlined" onClick={() => checkPass()}>
            {langData[props.language].register.registerBtn}
          </Button>
          <br />
          <hr />
          <Button
            variant="outlined"
            onClick={() => props.toggleInputMode("login")}
          >
            {langData[props.language].register.backBtn}
          </Button>
        </div>
      </Paper>
    </div>
  );
}
